import * as React from "react";
import styled from "styled-components";
import { Typography } from "@material-ui/core";

type Props = {
  link: string;
  text?: string | null;
  type?: "url" | "phone" | "email";
};

const StyledLink = styled.a`
  color: ${props => props.theme.palette.primary.main};
  text-decoration: none;
`;

export const PrimaryLink: React.FunctionComponent<Props> = props => {
  const getHrefPrefix = () => {
    switch (props.type) {
      case "email":
        return "mailto:";
      case "phone":
        return "tel:";
      default:
        return "";
    }
  };

  const formatLink = () => {
    return props.link.split(" ").join("");
  };

  return (
    <StyledLink target="_blank" href={`${getHrefPrefix()}${formatLink()}`}>
      <Typography component={"span"}>{props.text ?? props.link}</Typography>
    </StyledLink>
  );
};
